// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Entry imports
const BannerSection = require('./component-dumb')

function mapStateToProps(state) {
  return {
    domain: state.bannerSection.domain
  }
}

module.exports = connect(
  mapStateToProps
)(
  withImmutableToJS(
    BannerSection
  )
)
